/* clarity-events.js — Microsoft Clarity event + tag layer for Shopify
 * Loaded via theme.liquid. Works alongside GTM (GTM-T2J8BD65).
 * Pushes to dataLayer AND calls window.clarity() directly.
 */
(function () {
  'use strict';

  // ─── Queue: clarity stub may not be ready when this runs ───
  var _q = [];
  function clar() {
    var args = arguments;
    if (typeof window.clarity === 'function') {
      try { window.clarity.apply(null, args); } catch (e) {}
    } else {
      _q.push(args);
      if (!window._cqInterval) {
        window._cqInterval = setInterval(function () {
          if (typeof window.clarity === 'function') {
            _q.forEach(function (a) { try { window.clarity.apply(null, a); } catch (e) {} });
            _q = [];
            clearInterval(window._cqInterval);
            window._cqInterval = null;
          }
        }, 250);
      }
    }
  }

  function dl(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function track(eventName, props) {
    clar('event', eventName);
    dl(Object.assign({ event: eventName }, props || {}));
  }

  function setTag(key, value) {
    if (value === null || value === undefined || value === '') return;
    clar('set', String(key), String(value));
  }

  // ─── Page-load tags ───
  function initTags() {
    try {
      var url = new URL(window.location.href);
      var params = url.searchParams;
      var path = url.pathname || '/';

      // Traffic source
      var src = params.get('utm_source')
        || (params.get('fbclid') ? 'facebook' : null)
        || (params.get('gclid') ? 'google' : null)
        || (document.referrer ? (function () {
              try { return new URL(document.referrer).hostname; } catch (e) { return null; }
            })() : 'direct');
      setTag('traffic_source', src);
      ['utm_campaign', 'utm_medium', 'utm_content', 'utm_term'].forEach(function (k) {
        if (params.get(k)) setTag(k, params.get(k));
      });

      // Page type
      var pageType = 'other';
      if (path === '/' || path === '') pageType = 'home';
      else if (path.indexOf('/products/') === 0) pageType = 'product';
      else if (path.indexOf('/collections/') === 0) pageType = 'collection';
      else if (path === '/cart') pageType = 'cart';
      else if (path.indexOf('/pages/') === 0) pageType = 'page';
      else if (path.indexOf('/blogs/') === 0) pageType = 'blog';
      else if (path.indexOf('/account') === 0) pageType = 'account';
      setTag('page_type', pageType);

      // Logged in
      var loggedIn = !!(window.Shopify && window.Shopify.customer);
      setTag('logged_in', loggedIn ? 'true' : 'false');

      // Repeat visitor
      try {
        if (localStorage.getItem('ev_visited')) {
          setTag('repeat_visitor', 'true');
        } else {
          localStorage.setItem('ev_visited', String(Date.now()));
          setTag('repeat_visitor', 'false');
        }
      } catch (e) {}

      // Currency / locale
      if (window.Shopify) {
        if (window.Shopify.currency && window.Shopify.currency.active) setTag('currency', window.Shopify.currency.active);
        if (window.Shopify.locale) setTag('locale', window.Shopify.locale);
      }
    } catch (e) {}
  }

  // ─── Cart state polling ───
  var lastCartCount = null;
  function refreshCartTags(reason) {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var totalMinor = cart.total_price || 0;
        var totalMajor = (totalMinor / 100).toFixed(2);
        setTag('cart_value', totalMajor);
        setTag('cart_items', cart.item_count);
        setTag('cart_currency', cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR');

        if (lastCartCount !== null && cart.item_count < lastCartCount && reason !== 'init') {
          track('remove_from_cart', { items_after: cart.item_count, value: parseFloat(totalMajor) });
        }
        lastCartCount = cart.item_count;
        return cart;
      })
      .catch(function () { /* ignore */ });
  }

  // ─── Page-specific events ───
  function pageEvents() {
    var path = window.location.pathname || '/';
    if (path === '/cart') track('cart_view');
    if (path.indexOf('/products/') === 0) {
      var p = (window.meta && window.meta.product) || null;
      track('product_view', p ? {
        product_id: p.id,
        product_type: p.type,
        product_vendor: p.vendor
      } : {});
      if (p && p.type) setTag('product_type', p.type);
      if (p && p.vendor) setTag('product_vendor', p.vendor);
    }
    if (path.indexOf('/collections/') === 0) {
      var slug = path.split('/')[2] || '';
      if (slug) setTag('collection_slug', slug);
    }
  }

  // ─── Intercept cart API ───
  function hookCartApi() {
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(url)) {
          p.then(function () { track('add_to_cart'); refreshCartTags('add'); }).catch(function () {});
        } else if (/\/cart\/(change|update)(\.js|\.json)?(\?|$)/.test(url)) {
          p.then(function () { refreshCartTags('change'); }).catch(function () {});
        } else if (/\/cart\/clear(\.js|\.json)?(\?|$)/.test(url)) {
          p.then(function () { track('cart_clear'); lastCartCount = 0; refreshCartTags('clear'); }).catch(function () {});
        }
        return p;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._cq_url = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      var url = this._cq_url || '';
      this.addEventListener('load', function () {
        if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(url)) {
          track('add_to_cart'); refreshCartTags('add');
        } else if (/\/cart\/(change|update)(\.js|\.json)?(\?|$)/.test(url)) {
          refreshCartTags('change');
        } else if (/\/cart\/clear(\.js|\.json)?(\?|$)/.test(url)) {
          track('cart_clear'); lastCartCount = 0; refreshCartTags('clear');
        }
      });
      return origSend.apply(this, arguments);
    };
  }

  // ─── Click signals (checkout, ATC, primary CTA) ───
  function hookClicks() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[name="checkout"], [href*="/checkout"], button[formaction*="/checkout"]')) {
        track('checkout_started');
      }
      if (t.closest('[name="add"], .product-form__cart-submit, .product-form__submit, button[data-add-to-cart]')) {
        track('add_to_cart_click');
      }
    }, true);
  }

  // ─── Boot ───
  function boot() {
    initTags();
    refreshCartTags('init');
    pageEvents();
    hookCartApi();
    hookClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
